import { DataGrid, GridToolbar, GridFilterPanel } from "@mui/x-data-grid";
import { useContext } from "react";
import AppContext from "../../context/AppContext";
import { useHistory, useLocation } from "react-router-dom"
const AssetReport = () => {
  const { asset, loading } = useContext(AppContext)
  const history = useHistory()
  const location = useLocation()

  const columns = [

    {
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: "asset_name",
      headerName: "Asset Name",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Asset Name "}</strong>
      ),
      renderCell: (params) => (
        <div
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => history.push(`/reports/asset-name/${params.row.asset_name}`)}

        >
          <button
            style={{
              border: "none",
              backgroundColor: "transparent",
              cursor: "pointer",
              textDecoration: "underline",
              color: 'green'
            }}
          >
            {params.row.asset_name}
          </button>
        </div>
      ),
      sortable: false,
      disableSelectionOnClick: true,
    },


    {
      field: "beacon_mac",
      headerName: "MAC ID",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"MAC ID "}</strong>
      ),
    },
    {
      field: "ts",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Created At "}</strong>
      ),
    },
    {
      field: "gateway_unique_id",
      headerName: "gateway_unique_id",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Connected Gateway Id "}</strong>
      ),
    },
    {
      field: "gateway_id",
      headerName: "gateway_id",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Connected Gateway IMEI "}</strong>
      ),
      renderCell: (params) => (
        <div
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => history.push(`/reports/gateway-id/${params.row.gateway_id}`)}
        >
          <button
            style={{
              border: "none",
              backgroundColor: "transparent",
              cursor: "pointer",
              textDecoration: "underline",
              color: 'green'
            }}
          >
            {params.row.gateway_id}
          </button>
        </div>
      )
    },
    {
      field: "latest_timestamp",
      headerName: "gateway_id",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Last Connected "}</strong>
      ),
    },
    // {
    //   width: 200,
    //   align: "center",
    //   renderCell: (params) => (
    //     <div
    //       style={{ cursor: "pointer", textDecoration: "underline" }}
    //       onClick={() => handleAssetClick(params.row)}
    //     >
    //       <button
    //         style={{
    //           border: "none",
    //           backgroundColor: "transparent",
    //           cursor: "pointer",
    //           textDecoration: "underline",
    //           color: 'green'
    //         }}
    //       >
    //         View Details
    //       </button>
    //     </div>
    //   ),
    // },
  ];


  return (
    <div style={{ height: 500 }}>
      <DataGrid
        rows={asset}
        columns={columns}
        pageSize={10}
        loading={loading}
        rowSelection={false}
        rowsPerPageOptions={[10, 20, 30]}
        density="compact"
        components={{
          Toolbar: GridToolbar,
          FilterPanel: GridFilterPanel,
        }}
        slotProps={{
          filterPanel: {
            sx: {
              width: "100%",          // full width responsive
              maxWidth: "100%",
              padding: "10px",
              "& .MuiDataGrid-filterForm": {
                flexDirection: "column",
                gap: "10px",
              },
            },
          },
        }}
        pagination
      />
    </div>
  )
}

export default AssetReport